// extracted by mini-css-extract-plugin
export default {"root":"KMG8FTpREFJw1e12jE1Q"};